import script from "./Text.vue?vue&type=script&setup=true&lang=ts"
export * from "./Text.vue?vue&type=script&setup=true&lang=ts"

import "./Text.vue?vue&type=style&index=0&id=8bda704a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bda704a"]])

export default __exports__